// extracted by mini-css-extract-plugin
export default {"heroImgContainer":"Header_heroImgContainer__LtYXc","heroImg":"Header_heroImg__O0hVh"};